import { UserAvatar } from '../users/UserAvatar';

export const PERSON_COUNT_AVATAR_SIZE = 28;

interface PersonCountRowProps {
    name: string;
    count: number;
    // For buckets that aren't a named person, e.g. "Unknown" or a former user.
    muted?: boolean;
    // Small muted line under the name, e.g. where the count came from.
    detail?: string;
}

function nameClassName(muted: boolean): string {
    return `text-[13px] truncate ${muted ? 'text-gray-400 italic' : 'font-medium text-gray-700'}`;
}

export function PersonCountRow({ name, count, muted = false, detail }: PersonCountRowProps) {
    return (
        <div role="listitem" className="w-full flex items-center gap-3 px-5 py-2.5">
            <UserAvatar name={name} size={PERSON_COUNT_AVATAR_SIZE} />
            {detail ? (
                <div className="flex-1 min-w-0 flex flex-col">
                    <span className={nameClassName(muted)}>{name}</span>
                    <span className="text-[11px] text-gray-400 truncate tabular-nums">
                        {detail}
                    </span>
                </div>
            ) : (
                <span className={`flex-1 min-w-0 ${nameClassName(muted)}`}>{name}</span>
            )}
            <span
                className={`text-[13px] tabular-nums text-right ${
                    muted ? 'text-gray-400' : 'font-bold text-gray-800'
                }`}
            >
                {count.toLocaleString()}
            </span>
        </div>
    );
}
